import {MessageContent} from '#/repository/types';

export enum ActionMenuSection {
  INFORMATION = 'information',
  TRADE = 'trade',
  RENT = 'rent',
  TRANSACTION = 'transaction',
}

export type MessageCase = {
  condition: () => boolean;
  message: () => MessageContent;
};
